import { SESSION_STORAGE_AUTH } from '../constants';

class Authentication {
  accessToken: string;

  expiresIn: number;

  tokenType: string;

  constructor() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const authJson = window.sessionStorage.getItem(SESSION_STORAGE_AUTH);

      if (authJson) {
        const auth: {
          accessToken: string;
          expiresIn: number;
          tokenType: string;
          refreshToken: string;
        } = JSON.parse(authJson);
        this.accessToken = auth.accessToken;
        this.expiresIn = auth.expiresIn;
        this.tokenType = auth.tokenType;
        return;
      }
    }

    this.accessToken = '';
    this.expiresIn = 0;
    this.tokenType = '';
  }

  isLoggedIn() {
    return !!this.accessToken && !!this.tokenType;
  }

  getAccessToken() {
    return this.accessToken;
  }

  loggedIn(token: { accessToken: string; expiresIn: number; tokenType: string }) {
    const auth = {
      accessToken: token.accessToken,
      expiresIn: token.expiresIn,
      tokenType: token.tokenType,
    };

    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.setItem(SESSION_STORAGE_AUTH, JSON.stringify(auth));
    }

    this.accessToken = auth.accessToken;
    this.expiresIn = auth.expiresIn;
    this.tokenType = auth.tokenType;
  }

  logout() {
    window.sessionStorage.clear();
    this.accessToken = '';
    this.expiresIn = 0;
    this.tokenType = '';
  }
}

const Auth = new Authentication();

export default Auth;
